import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    profile: []
};

export const profileSlice = createSlice({
    name: 'profileSlice',
    initialState,
    reducers: {
        // a- getting Organization admin profile
        getProfile: (state, action) => {
            state.profile = action.payload;
        },
      
    },
});

// Action creators are generated for each case reducer function
export const { getProfile } = profileSlice.actions;

export default profileSlice.reducer;
